import api from '@/api';

const { $academic, $student, $pricing } = api;

export const { $ceos } = $academic;
export const { $examenes } = $student;
export const { $types } = $pricing;
